import { Product } from "../types/product";
import { AddOrUpdateProductReq } from "../request/addOrUpdateProductReq";
import axiosInstance, { axiosMultipartInstance } from "../config/axios";
import HttpService from "./httpService";
import { FileService } from "./fileService";

export interface AddOrUpdateProductData {
    data: any;
};



export class ProductService {


    static getStats = async () => {
        return HttpService.get<{ totalSales: number,
            totalOrders: number,
            totalProducts: number,
            totalCustomers: number}>(`/stats`)
    }

   
    static getProductById = async (id?: string | null) => {
        //console.log("Here")
        try {
            const response = await axiosInstance.get<Product>(`/products/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    static deleteProductById = async (id?: string | null) => {
        try {
            const response = await axiosInstance.delete(`/products/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static getAllProducts = async (): Promise<Product[]> => {

        console.log("getAllProducts is called")

        try {
            const response = await axiosInstance.get<Product[]>(`/products`);
            return response.data;
        } catch (error) {
            console.log(error)
            throw error;
        }
    }

    static addOrUpdateProduct = async ({ data }: AddOrUpdateProductData): Promise<Product> => {
        try {
            // Helper function to process images (upload Files, keep URLs)
            const processImages = async (images: (string | File)[]): Promise<string[]> => {
                const urls: string[] = [];
                const files: File[] = [];
                
                // Separate URLs and Files
                images.forEach(img => {
                    if (typeof img === 'string') {
                        urls.push(img); // Keep existing URLs
                    } else {
                        files.push(img); // Files need to be uploaded
                    }
                });
                
                // Upload new files if any
                if (files.length > 0) {
                    const uploadedFiles = (await FileService.uploadFiles(files)).files;
                    urls.push(...uploadedFiles.map(f => f.url));
                }
                
                return urls;
            };

            // Process base product images
            const baseImageUrls = await processImages(data.images || []);

            // Upload variant images if they exist
            if (data.hasVariants && data.variants) {
                console.log("=== SERVICE VARIANT DEBUG ===");
                console.log("Processing variants:", data.variants.length);
                data.variants.forEach((variant: any, index: number) => {
                    console.log(`Variant ${index}:`, {
                        attributes: variant.attributes,
                        existingImages: variant.existingImages?.length || 0,
                        newImages: variant.images?.length || 0,
                        existingImagesData: variant.existingImages,
                        newImagesData: variant.images
                    });
                });
                console.log("=== END SERVICE VARIANT DEBUG ===");
                
                // Process each variant's images
                for (const variant of data.variants) {
                    // Upload new images
                    const newImageUrls = await processImages(variant.images || []);
                    
                    // Combine existing URLs with new uploaded URLs
                    const allImageUrls = [...(variant.existingImages || []), ...newImageUrls];
                    
                    // Update the variant with combined image URLs
                    variant.images = allImageUrls;
                    delete variant.existingImages; // Remove the separate field
                }
            }

            // Prepare product data with processed image URLs
            const productData = { 
                ...data, 
                images: baseImageUrls,
                // Ensure ID is included for updates, or use empty string for new products
                id: data.id || ''
            } as AddOrUpdateProductReq;

            // Call the service to add or update the product
            return await HttpService.post<Product>(`/products`, productData);
        } catch (error) {
            throw error;
        }
    }
}


export const getAdminProduct = async (id: string) => {
    try {
        const response = await axiosInstance.get<Product>(`/admin/products/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}


export const getAllProduct = async () => {
    try {
        const response = await axiosInstance.get<Product[]>(`/admin/product`);
        return response.data;
    } catch (error) {
        throw error;
    }
}



export const addProduct = async (productReq: AddOrUpdateProductReq) => {
    try {
       return await HttpService.post<any>('/admin/product', productReq);
    } catch (error) {
        console.log(error)
        throw error;
    }
}